import axios, { AxiosInstance } from 'axios'

import { iamDefaultApiFactory } from '@src/api/default-api-factories'
import { DefaultApiLoginPostRequest } from '@src/api/generated/iam/api'
import { L_STORAGE_KEYS } from '@src/consts'
import { BASE_IAM_URL, lStorage } from '@src/utils'
const axiosIamInstance = axios.create({ baseURL: BASE_IAM_URL() })
axiosIamInstance.interceptors.request.use((config) => {
  const token = lStorage.getItem(L_STORAGE_KEYS.TOKEN)
  // To be able to request the Staging API from Local to increase development efficiency
  if (token && process.env.NODE_ENV !== 'production') {
    config.headers.Authorization = `Bearer ${token}`
  }

  // To access to internal client api not one for OAuth2.
  config.headers['upsidr-private-client-api-internal'] = 'true'

  return config
})

export const signout = async () => {
  return iamDefaultApiFactory(axiosIamInstance).logoutPost()
}
export const loginWithEmailAndPassword = async (
  instance: AxiosInstance,
  params: DefaultApiLoginPostRequest
) => {
  return await iamDefaultApiFactory(instance).loginPost(params)
}

// Do Not Remove this line ===@import api client===
